<style lang="less" scoped>
.max-height-table {
  max-height: 600px;
  overflow-y: auto;
}
.distpicker-address-wrapper {
  width: 355px !important;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">电站管理</div>
      <!-- <div class="page-title-div">电站管理</div> -->
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">电站搜索</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryInfo.stationName"
                placeholder="请输入电站名称或地址"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">电站编号</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryInfo.stationNo"
                placeholder="请输入内容"
                clearable
                @keyup.enter.native="getListData(pagination, true)"
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">运营状态</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                size="small"
                v-model="queryInfo.stationStatus"
                placeholder="请选择内容"
                clearable
              >
                <el-option label="未运营" value="01"></el-option>
                <el-option label="运营中" value="02"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">区域</div>
            <div class="query-inputs-div flex-1">
              <v-distpicker
                :placeholders="dp_placeholders"
                :province="select.province"
                :city="select.city"
                :area="select.area"
                @province="selectProvince"
                @city="selectCity"
                @area="selectArea"
              ></v-distpicker>
              <!-- <el-input :model="queryInfo.province" v-show="false"></el-input>
                            <el-input :model="queryInfo.city" v-show="false"></el-input>
                            <el-input :model="queryInfo.country" v-show="false"></el-input> -->
            </div>
          </div>
        </template>
        <template slot="actions">
          <button
            class="common-bg-button"
            @click="getListData(pagination, true)"
          >
            搜 索
          </button>
          <button class="common-empty-button" @click="reset()">重 置</button>
        </template>
      </ZD-list-querys>
      <div class="page-action-btns">
        <button
          class="common-bg-button"
          v-if="$S.checkUserMenu('PILE_STATION_ADD')"
          @click="listAddFun()"
        >
          新 增
        </button>
        <button
          class="common-bg-button"
          v-if="$S.checkUserMenu('PILE_STATION_EDIT')"
          @click="listEditFun()"
        >
          编 辑
        </button>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table
          :tableColumns="pageConfig.listColumns"
          :operates="operates"
          :tableData="tableData"
          :tableConfig="pageConfig.tableConfig"
          :selections="selections"
          v-on:updateSelections="
            (sels) => {
              selections = sels;
            }
          "
        ></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>

    <!-- 站点充电桩列表 -->
    <el-dialog
      title="电站充电桩"
      :visible.sync="stationPileDialogVisible"
      width="80%"
    >
      <el-table :data="stationPileList" border stripe class="max-height-table">
        <el-table-column
          type="index"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="pileCode"
          label="充电桩编号"
          align="center"
          width="200"
        >
          <div slot-scope="scope">
            <span v-if="scope.row.pileEntity">{{
              scope.row.pileEntity.pileCode+ '/' + row.gunPort
            }}</span>
          </div>
        </el-table-column>
        <el-table-column
          prop="stationName"
          label="所属站点"
          align="center"
          width="200"
        >
          <div slot-scope="scope">
            <span v-if="scope.row.pileEntity">{{
              scope.row.pileEntity.stationName
            }}</span>
          </div>
        </el-table-column>
        <el-table-column prop="ratedPower" label="功率" align="center">
          <div slot-scope="scope">
            <span v-if="scope.row.pileEntity">{{
              scope.row.pileEntity.ratedPower
            }}</span>
          </div>
        </el-table-column>
        <el-table-column
          prop="orderNum"
          label="订单数量（单）"
          align="center"
          width="150"
        >
          <div slot-scope="scope">
            <span v-if="scope.row.pileEntity">{{
              scope.row.pileEntity.orderNum
            }}</span>
          </div>
        </el-table-column>
        <el-table-column
          prop="pileStatusName"
          label="充电桩状态"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="repairStatusName"
          label="是否报修"
          align="center"
        >
          <div slot-scope="scope">
            <span v-if="scope.row.pileEntity">{{
              getStatus(scope.row.pileEntity.isRepair)
            }}</span>
          </div>
        </el-table-column>
        <el-table-column
          prop="repairStatusName"
          label="最近充电"
          align="center"
        >
          <div slot-scope="scope">
            <span v-if="scope.row.pileEntity">{{
              scope.row.pileEntity.latestChargeTime
            }}</span>
          </div>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center">
        </el-table-column>
        <!-- <el-table-column prop="pileCode" label="最近充电时间"  width="200" align="center">
                    <div slot-scope="scope">
                        <span v-if="scope.row.pileEntity">{{scope.row.pileEntity.ratedPower}}</span>
                    </div>
                </el-table-column> -->
      </el-table>
      <div class="list-pagination">
        <ZD-pagination
          :pagination="dialogPagination"
          v-on:pageUpdate="getStationPiles"
        ></ZD-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      dialogPagination: pageConfig.dialogPagination,
      queryInfo: {},
      operates: {
        width: 220,
        fixed: "right",
        list: [
          // {
          //   id: "report",
          //   label: "报表",
          //   type: "primary",
          //   show: true,
          //   disabled: false,
          //   method: (index, row) => {
          //     this.$store.commit("setEditId", row.id),
          //       this.$store.commit("setStationNo", row.stationNo);
          //     // this.$router.push({
          //     //     name: pageConfig.reportDetailRouter,
          //     // });
          //     window.open(
          //       this.$router.resolve({ name: pageConfig.reportDetailRouter })
          //         .href,
          //       "_blank"
          //     );
          //   },
          // },
          {
            id: "expenses",
            label: "资费",
            type: "primary",
            show: true,
            disabled: false,
            auth: true,
            authName: "PILE_STATION_MONEY",
            method: (index, row) => {
              this.$store.commit("setStationObj", row);
              // this.$router.push({
              // 	name: pageConfig.postageDetailRouter
              // });
              window.open(
                this.$router.resolve({ name: pageConfig.postageDetailRouter })
                  .href,
                "_blank"
              );
            },
          },
          {
            id: "order",
            label: "订单",
            type: "primary",
            show: true,
            disabled: false,
            auth: true,
            authName: "PILE_STATION_ORDER",
            method: (index, row) => {
              this.$router.push({
                name: pageConfig.orderListRouter,
                params: {
                  stationNo: row.stationNo,
                },
              });
              window.open(
                this.$router.resolve({
                  name: pageConfig.orderListRouter,
                  query: { stationNo: row.stationNo },
                }).href,
                "_blank"
              );
            },
          },
          {
            id: "pile",
            label: "充电桩",
            type: "primary",
            auth: true,
            authName: "PILE_STATION_PILE",
            show: true,
            disabled: false,
            method: (index, row) => {
              this.rowStationNo = row.stationNo;
              this.getStationPiles(this.rowStationNo);
            },
          },
          {
            id: "tariff",
            label: "资费策略",
            type: "primary",
            show: true,
           
            disabled: false,
            method: (index, row) => {
              this.$store.commit("setEditId", row.chargeNo);
              window.open(
                this.$router.resolve({
                  name: pageConfig.tariffDetailRouter,
                  query: { stationNo: row.stationNo },
                }).href,
                "_blank"
              );
            },
          },
          {
            id: "replenishment",
            label: "补能策略",
            type: "primary",
            show: true,
            disabled: false,
            method: (index, row) => {
              this.$store.commit("setEditId", row.id);
              // this.$router.push({
              // name: pageConfig.replenishmentDetailRouter
              // });
              window.open(
                this.$router.resolve({
                  name: pageConfig.replenishmentDetailRouter,
                  query: { stationNo: row.stationNo },
                }).href,
                "_blank"
              );
            },
          },
          {
            id: "feedforward",
            label: "馈网策略",
            type: "primary",
            show: true,
            disabled: false,
            method: (index, row) => {
              this.$store.commit("setEditId", row.id);
              // this.$router.push({
              // name: pageConfig.feedforwardDetailRouter
              // });
              window.open(
                this.$router.resolve({
                  name: pageConfig.feedforwardDetailRouter,
                  query: { stationNo: row.stationNo },
                }).href,
                "_blank"
              );
            },
          },
          // {
          // 	id: "settlement",
          //     label: "结算记录",
          //     type:"primary",
          // 	show: true,
          // 	disabled: false,
          // 	method: (index, row) => {
          // 		this.$store.commit('setEditId', row.id)
          // 		this.$router.push({
          // 			name: pageConfig.settlementDetailRouter
          // 		});
          // 	}
          // },
        ],
      }, // 列操作按钮
      dp_placeholders: {
        province: "------- 省 --------",
        city: "--- 市 ---",
        area: "--- 区 ---",
      },
      select: {
        province: "",
        city: "",
        area: "",
      },
      stationPileDialogVisible: false,
      stationPileList: [],
      rowStationNo: "",
    };
  },
  methods: {
    init() {
      this.getListData(this.pagination, true);
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.$H.get(_, _.$A.pilestation.pilestation, _.queryInfo).then((res) => {
        let resdata = res.data.data.content || [];
        _.tableData = [];
        resdata.forEach((item) => {
          item.ttlVal = "";
          item.tId = "";
          if (item["pileChargeEntity"]) {
            item.ttlVal = item["pileChargeEntity"].ttlVal;
            item.tId = item["pileChargeEntity"].id;
          }
          _.tableData.push(item);
        });
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    // 页面新增方法
    listAddFun() {
      this.$S.listAddFun(this, pageConfig.tableEditObj);
    },
    // 页面编辑方法
    listEditFun() {
      this.$S.tableEditFun(this, this.selections, pageConfig.tableEditObj);
    },
    listDetailFun() {
      this.$router.push({
        name: pageConfig.detailRouter,
      });
    },
    selectProvince(value) {
      this.select.province = value.value;
      if (value.code == undefined) {
        this.queryInfo.province = "";
      } else {
        this.queryInfo.province = this.select.province;
      }
    },
    selectCity(value) {
      this.select.city = value.value;
      if (value.code == undefined) {
        this.queryInfo.city = "";
      } else {
        this.queryInfo.city = value.value;
      }
    },
    selectArea(value) {
      this.select.area = value.value;
      if (value.code == undefined) {
        this.queryInfo.county = "";
      } else {
        this.queryInfo.county = value.value;
      }
    },
    // 获取站点充电桩列表
    getStationPiles(val) {
      let _ = this;
      // let pageInfo = {};
      // pageInfo.stationNo = _.rowStationNo;
      // pageInfo.pageNum = dialogPagination.current - 1;
      // if (reload) {
      //     pageInfo.pageNum = 0;
      // }
      // pageInfo.pageSize = dialogPagination.pageSize;
      // _.$H.post(_, _.$A.pile.pile, pageInfo).then(res => {
      //     _.stationPileList = res.data.data.content || [];
      //     _.dialogPagination.total = res.data.data.totalElements || 0;
      //     _.stationPileDialogVisible = true;
      // });
      var url = _.$router.resolve({
        name: "pileList",
        query: { stationNo: val },
      });
      window.open(url.href, "_blank");
    },
    reset() {
      this.pagination.current = 1;
      delete this.queryInfo.stationNo;
      delete this.queryInfo.stationStatus;
      delete this.queryInfo.dealName;
      delete this.queryInfo.stationName;
      delete this.queryInfo.province;
      delete this.queryInfo.city;
      delete this.queryInfo.county;
      this.select.province = "";
      this.select.city = "";
      this.select.area = "";
      this.init();
    },
    getStatus(i) {
      if (i == "Y") {
        return "已报修";
      } else {
        return "未报修";
      }
    },
  },
  mounted() {
    this.init();
    // 操作按钮过滤
    this.operates.list = this.$S.checkListAuthBtn(this.operates.list);
  },
};
</script>
